import { useEffect, useState } from 'react';

export const useElementRect = (elementId: string): DOMRectReadOnly | undefined => {
    const [elementRect, setElementRect] = useState<DOMRectReadOnly | undefined>(undefined);

    useEffect(() => {
        let observer: IntersectionObserver;
        const projectFormContainer = document.getElementById(elementId);
        if (projectFormContainer) {
            observer = new IntersectionObserver(_ => {
                let rect = document.getElementById(elementId)?.getBoundingClientRect();
                setElementRect(rect);
            });
            observer.observe(projectFormContainer);
        }

        return () => {
            if (observer) {
                observer.disconnect();
            }
        };
    }, []);

    return elementRect;
}